import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-disable react/prop-types */
import React, { PureComponent } from 'react';
import Group, { Heading, HeadingAfter, HeadingText } from '../styled/Group';

var DroplistGroup = /*#__PURE__*/function (_PureComponent) {
  _inherits(DroplistGroup, _PureComponent);

  var _super = _createSuper(DroplistGroup);

  function DroplistGroup() {
    var _this;

    _classCallCheck(this, DroplistGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      ariaLabel: _this.props.heading
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (_this.props.heading || _this.props.elemAfter) {
        _this.setState({
          ariaLabel: _this.getAriaLabel()
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function () {
      if (_this.props.heading || _this.props.elemAfter) {
        // eslint-disable-next-line react/no-did-update-set-state
        _this.setState({
          ariaLabel: _this.getAriaLabel()
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getAriaLabel", function () {
      var _this$props = _this.props,
          elemAfter = _this$props.elemAfter,
          heading = _this$props.heading;
      var afterText = elemAfter && typeof elemAfter === 'string' ? elemAfter : _this.headingElement && _this.headingElement.textContent;
      return "".concat(heading || '', " ").concat(afterText || '');
    });

    return _this;
  }

  _createClass(DroplistGroup, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          children = _this$props2.children,
          elemAfter = _this$props2.elemAfter,
          heading = _this$props2.heading;
      var ariaLabel = this.state.ariaLabel;
      return /*#__PURE__*/React.createElement(Group, {
        "aria-label": ariaLabel,
        role: "group"
      }, heading ? /*#__PURE__*/React.createElement(Heading, {
        "aria-hidden": "true",
        "data-role": "droplistGroupHeading"
      }, /*#__PURE__*/React.createElement(HeadingText, null, heading), elemAfter ? /*#__PURE__*/React.createElement(HeadingAfter, {
        innerRef: function innerRef(r) {
          _this2.headingElement = r;
        }
      }, elemAfter) : null) : null, children);
    }
  }]);

  return DroplistGroup;
}(PureComponent);

DroplistGroup.displayName = 'Group';
export default DroplistGroup;